import Content from "./BackupProgramsSidebar";
import Protector from "./BackupProgramProtector";
import ErrorMessage from "./BackupProgramsError";
export var BackupProgramsSidebar = Protector(ErrorMessage)(Content);